// @flow
import styled, { css } from "styled-components"
import { NavLink } from "react-router-dom"

const sharedStyle = ((css`
  font-size: 1.6rem;
  color: ${(props) => props.theme.color.primaryAccent};
  cursor: pointer;
  ${p => p.underline &&
  css`
      &:hover {
        text-decoration: underline;
      }
    `}
`))

export const StyledHref = styled.a`
  ${sharedStyle};
`

export const StyledNavLink = styled(NavLink)`
  ${sharedStyle};
`



// WEBPACK FOOTER //
// ./src/components/StyledLink/styled.js